<template>
  <!-- 加入行事曆視窗 -->
  <ui-modal ref="bookingAddToCalendarModal" :header-title="$t('add_to_calendar')" :hide-overlay="false" forcing>
    <v-sheet class="calendar-modal wd-p-0 wd-text-center" max-width="440">
      <v-radio-group v-model="calendar" hide-details density="compact">
        <div v-for="(c, index) in calendarOptions" :key="c.value">
          <v-radio class="wd-my-4 wd-px-6 wd-text-osm wd-font-normal calendar-radio" color="orange50" :label="c.label" :value="c.value" />
          <v-divider v-if="index < calendarOptions.length - 1" />
        </div>
      </v-radio-group>
    </v-sheet>

    <template #buttons>
      <div class="event-buttons-group d-flex justify-end mt-2">
        <v-spacer />
        <!-- 確認 -->
        <v-btn class="confirm-btn text-white" color="orange50" :min-width="66" :min-height="40" variant="flat" @click="confirm">
          {{ $t('all_ok') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import UiModal from '@/components/dialog/ui-modal'
import { useOrderCalendar } from '@/composition/useBookingCalendar'

export default defineComponent({
  components: {
    UiModal,
  },
  props: {
    order: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const bookingAddToCalendarModal = ref(null)
    const calendar = ref('google')
    const calendarOptions = computed(() => [
      { label: nuxtApp.$i18n.t('add_to_calendar_apple'), value: 'apple' },
      { label: nuxtApp.$i18n.t('add_to_calendar_google'), value: 'google' },
    ])

    const { downloadAppleCalendar, downloadGoogleCalendar } = useOrderCalendar(computed(() => props.order))

    function showModal() {
      bookingAddToCalendarModal.value.showModal()
    }

    function hideModal() {
      bookingAddToCalendarModal.value.hideModal()
    }

    function confirm() {
      hideModal()
      switch (calendar.value) {
        case 'google':
          downloadGoogleCalendar()
          break
        case 'apple':
          downloadAppleCalendar()
      }
    }

    return {
      bookingAddToCalendarModal,
      calendar,
      calendarOptions,
      showModal,
      hideModal,
      confirm,
    }
  },
})
</script>

<style lang="scss">
.calendar-radio {
  .theme--light.v-label {
    color: $black50;
  }
}
</style>
